<ng-container *ngIf="!composeMessage">
    <app-chat [incomingChannelId]="channelId" [isDirectPopUp]="true"></app-chat>
</ng-container>
<ng-container *ngIf="composeMessage">
    <app-message-compose [composeUserId]="composeUserId">
    </app-message-compose>
</ng-container>
